<template>
  <layout-default>
    <!-- <template v-slot:toolbar>
      <chat-toolbar-icons />
    </template> -->
    <template v-slot:pageAction>
      <v-btn
        v-if="
          currentChannel &&
            currentChannelData &&
            !currentChannelData.isDirectMessage
        "
        medium
        class="elevation-0 mr-3"
        color="primary"
        rounded
        @click="showEditChatDialog"
      >
        <v-icon size="24" class="mr-2"> mdi-pencil </v-icon>edit group chat
      </v-btn>
      <v-btn
        medium
        class="elevation-0"
        color="primary"
        rounded
        @click="showNewChatDialog"
      >
        <v-icon size="24" class="mr-2"> mdi-plus </v-icon>new chat
      </v-btn>
    </template>
    <div class="chat">
      <v-overlay :value="loading" z-index="4">
        <v-progress-circular indeterminate size="64" />
      </v-overlay>
      <chat-drawer
        :chats="
          sortedChannels(
            searchChannels,
            chatTypes.length && !searchChannels.length
              ? chatListType
              : allChatTypes,
          )
        "
        :chats-unreaded-messages="unreadMessagesObject"
        :current-chat="currentChannel"
        :current-user="uuid"
        :last-chats-messages="lastChatsMessages"
        :roles="roles"
        :is-admin="isAdmin"
        has-header
        @itemSelected="channelSelected"
        @toggleChannelIsPinned="toggleChannelIsPinnedHandler"
        @setChatArchive="setCurrentChatArchive"
      >
        <template v-slot:header>
          <bh-input-pill
            :disabled="channelsLength === 0"
            class="py-3"
            placeholder="Search"
            bgColor="bhWhite"
            v-model="searchChannels"
          />
          <div
            class="mx-2"
            v-if="
              (!searchChannels || (searchChannels && !searchChannels.length)) &&
                chatTypes &&
                chatTypes.length
            "
          >
            <bh-tabs-radios
              v-model="chatListType"
              class="mb-3"
              :values="chatTypes"
              fullWidth
              withBg
            />
          </div>
        </template>
      </chat-drawer>
      <chat-messages
        :chats-counter="channelsLength"
        :messages="currentMessages"
        :current-chat="currentChannel"
        :history-messages-counter="historyMessagesCounter"
        :current-user="uuid"
        :active-writers="activeWritersNames"
        :parse-input-message-text="parseInputMessageText"
        :parse-output-message-text="parseOutputMessageText"
        :emoji="emoji"
        :chat-users="channelUsers(currentChannel)"
        :quick-messages="quickMessages"
        :get-file-url="getFileUrlHandler"
        :has-full-history="channelWithFullHistory[currentChannel]"
        :channel-initialized="initializedChannels[currentChannel]"
        :get-message-by-timetoken="getMessageByTimetokenHandler"
        :get-resource-by-url="getResourceByUrl"
        :get-resource-by-id="getResourceById"
        :direct-chat="currentChannelData && currentChannelData.isDirectMessage"
        :enabled-ack-button="
          !(currentChannelData && !!currentChannelData.isFreeUserChat)
        "
        :enabled-gif-button="
          !(currentChannelData && !!currentChannelData.isFreeUserChat)
        "
        :enabled-media-library-button="
          !(currentChannelData && !!currentChannelData.isFreeUserChat)
        "
        :enabled-upload-button="
          !(currentChannelData && !!currentChannelData.isFreeUserChat)
        "
        :send-existing-resource="sendExistingResource"
        :send-resource="sendResource"
        :get-mime-types="getMimeTypes"
        @addMessage="addMessage"
        @ackMessage="ackMessageHandler"
        @copyMessage="copyMessageHandler"
        @askAi="askAiHandler"
        @removeMessage="removeMessageHandler"
        @addMessageAction="addMessageActionHandler"
        @removeMessageAction="removeMessageActionHandler"
        @markMessagesAsRead="markMessagesAsReadHandler"
        @sendWritingSignal="sendWritingSignal"
        @downloadFile="downloadFileHandler"
        @downloadResourceByUrl="downloadResourceByUrlHandler"
        @getMoreMessages="getMoreMessagesHandler"
      />
      <new-chat-dialog
        :step="step"
        :show-dialog="newChatDialog"
        :contacts="filteredContacts(searchChatUsers)"
        :selected-contacts="selectedChatMembers"
        :loading="loading"
        :search="search"
        :selected-contacts-limit="contactsSelectionLimit"
        :current-channel-data="currentChannelData"
        :contactSingleSelection="contactSingleSelection"
        @onDialogNextStep="onDialogNextStep"
        @onDialogPreviousStep="onDialogPreviousStep"
        @contact:search="searchChatUsers = $event"
        @contact:selection="toggleContactSelection"
        @close-dialog="closeNewUserDialog"
        @on-submit="onNewChatSubmit"
        @setContactSelectionOptionIsSingle="
          setContactSelectionOptionIsSingleHandler
        "
      />
      <ask-ai-dialog
        :show-dialog="showAiDialog"
        :question="aiQuestion"
        :answer="aiAnswer.samiAnswer"
        :loading="aiLoading"
        @close-dialog="closeAiDialog"
        @askQuestion="sendAiQuestionHandler"
        @confirmAnswer="sendAiAnswerHandler"
      />
    </div>
  </layout-default>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import ChatCore from '@/mixins/chat/core'
import LayoutDefault from '@/layouts/LayoutDefault.vue'
import NewChatDialog from '@/components/dialogs/NewChatDialog.vue'
import AskAiDialog from '@/components/dialogs/AskAiDialog.vue'
import ChatDrawer from '@/components/ChatDrawer.vue'
// import ChatToolbarIcons from "@/components/chat/components/ChatToolbarIcons.vue"
import ChatMessages from '@/components/chat/ChatMessages.vue'
import BhTabsRadios from '@/components/inputs/BhTabsRadios.vue'
import BhInputPill from '@/components/inputs/BhInputPill.vue'
import { prepareUpdatedChatMembers, CHATS_LIST_TYPE } from '@/helpers/chat.js'

export default {
  name: 'Chat',
  mixins: [ChatCore],
  components: {
    LayoutDefault,
    NewChatDialog,
    AskAiDialog,
    ChatDrawer,
    ChatMessages,
    // ChatToolbarIcons,
    BhTabsRadios,
    BhInputPill,
  },
  created() {
    this.getQuickMessages()
    this.getChatChannels()
  },
  data() {
    return {
      // 'NEW' or 'EDIT', depends on that for what used is chat dialog
      newChatDialogType: 'NEW',
      newChatDialog: false,
      showAiDialog: false,
      aiQuestion: '',
      aiAnswer: {},
      aiProfileId: false,
      aiLoading: false,
      searchChannels: '',
      searchChatUsers: '',
      step: 1,
      chatListType: CHATS_LIST_TYPE.NORMAL_CHATS,
    }
  },
  watch: {
    chatListType() {
      if (this.chatListType === CHATS_LIST_TYPE.NORMAL_CHATS) {
        this.getChatChannels()
      }
    },
  },
  computed: {
    ...mapState('userStates', ['user', 'userTenant']),
    ...mapGetters('userStates', ['getRolename']),
    ...mapState('dictionariesStates', [
      'dictionaryBhUsersRoleIds',
      'dictionaryPracticeUserRole',
    ]),
    ...mapGetters('dictionariesStates', ['getMimeTypes']),
    ...mapState('chatStates', [
      'loading',
      'contactsSelectionLimit',
      'search',
      'currentChannel',
      'historyMessagesCounter',
      'currentChannelData',
      'uuid',
      'contactSingleSelection',
      'channelWithFullHistory',
      'unreadMessagesObject',
      'initializedChannels',
    ]),
    ...mapGetters('chatStates', [
      'filteredContacts',
      'selectedContacts',
      'currentMessages',
      'channelUsers',
      'lastChatsMessages',
      'activeWritersNames',
      'sortedChannels',
      'channelsLength',
      'directMessageUsers',
      'freeChatsUnreadMessages',
      'normalChatsUnreadMessages',
    ]),
    editingChannel() {
      return this.step > 2
    },
    roles() {
      return {
        ...this.dictionaryBhUsersRoleIds,
        ...this.dictionaryPracticeUserRole,
      }
    },
    isAdmin() {
      return (
        this.dictionaryBhUsersRoleIds[this.getRolename] ===
        this.dictionaryBhUsersRoleIds.Admin
      )
    },
    isCompanyAdvisor() {
      return (
        this.dictionaryPracticeUserRole[this.getRolename] ===
        this.dictionaryPracticeUserRole.Advisor
      )
    },
    isCompanyAdmin() {
      return (
        this.dictionaryPracticeUserRole[this.getRolename] ===
        this.dictionaryPracticeUserRole.Administrator
      )
    },
    usersCompanyIsTenant() {
      // Check if logged user's company is tenant
      return this.userTenant !== null && this.userTenant !== undefined
    },
    chatTypes() {
      if (this.isAdmin || (this.isCompanyAdmin && this.usersCompanyIsTenant)) {
        // User is SS Admin or User is Company admin and his company is tenant
        return [
          {
            name: 'Group & Direct',
            badgeValue: this.normalChatsUnreadMessages,
            value: CHATS_LIST_TYPE.NORMAL_CHATS,
          },
          {
            name: 'Free Users',
            badgeValue: this.freeChatsUnreadMessages,
            value: CHATS_LIST_TYPE.FREE_CHATS,
          },
        ]
      } else if (this.isCompanyAdvisor) {
        // Company advisor
        return [
          {
            name: 'Group & Direct',
            badgeValue: this.normalChatsUnreadMessages,
            value: CHATS_LIST_TYPE.NORMAL_CHATS,
          },
          {
            name: 'Sprint messages',
            badgeValue: this.sprintChatsUnreadMessages,
            value: CHATS_LIST_TYPE.SPRINT_CHATS,
          },
        ]
      }
      return []
    },
    allChatTypes() {
      return CHATS_LIST_TYPE.ALL
    },
    selectedChatMembers() {
      if (this.newChatDialogType === 'NEW') return [...this.selectedContacts]

      const chatMembers = this.channelUsers(this.currentChannel)
      const freeUser = chatMembers.find(user => !!user.isFreeUser)

      if (freeUser) {
        freeUser.isFreeUser = true
        return [...this.selectedContacts, freeUser]
      }

      return [...this.selectedContacts]
    },
  },
  beforeDestroy() {
    this.setCurrentChannel('')
  },
  methods: {
    ...mapActions('resourcesStates', [
      'getResourceByUrl',
      'getResourceById',
      'sendExistingResource',
      'downloadResourceByUrl',
      'sendResource',
    ]),
    ...mapActions('chatStates', [
      'getAllChatUsers',
      'createChat',
      'updateChat',
      'setContactSelectionOptionIsSingle',
      'getMoreMessages',
      'setCurrentChannel',
      'getChatChannels',
      'sendAiQuestion',
      'sendAiAnswer',
    ]),
    ...mapMutations('chatStates', [
      'toggleContactSelection',
      'toggleContactsOnInit',
    ]),
    showNewChatDialog() {
      this.getAllChatUsers()
      this.newChatDialogType = 'NEW'
      this.newChatDialog = true
      this.step = 1
    },
    async showEditChatDialog() {
      this.newChatDialogType = 'EDIT'
      this.setContactSelectionOptionIsSingle(false)
      await this.getAllChatUsers()
      this.newChatDialog = true
      this.step = 3
      this.toggleContactsOnInit(this.currentChannelData.chatMembers || [])
    },
    closeNewUserDialog() {
      this.newChatDialog = false
      this.step = 1
      this.setContactSelectionOptionIsSingle(true)
    },
    onDialogNextStep() {
      if (this.step === 1 && this.contactSingleSelection) {
        const selectedUser = this.selectedContacts[0]
        const findDirectChannel = this.directMessageUsers.find(
          user => user.uuid === selectedUser.uuid,
        )

        if (findDirectChannel && findDirectChannel.id) {
          this.closeNewUserDialog()
          this.setCurrentChannel(findDirectChannel.id)
          return
        }

        this.onNewChatSubmit({
          contacts: [...this.selectedContacts],
          subject: '',
        })
        return
      }

      this.step = this.step + 1
    },
    onDialogPreviousStep() {
      this.step = this.step - 1
    },
    async onNewChatSubmit(userData) {
      let resp = null
      if (this.editingChannel) {
        const contacts = prepareUpdatedChatMembers(
          this.currentChannelData.chatMembers,
          userData.contacts,
          this.uuid,
        )
        resp = await this.updateChat({ ...userData, contacts })
      } else {
        resp = await this.createChat(userData)
      }

      if (resp && resp.status === 200) {
        this.closeNewUserDialog()
      }
    },
    getMoreMessagesHandler() {
      this.getMoreMessages({})
    },
    askAiHandler(messageText, profileId) {
      this.aiQuestion = messageText
      this.aiProfileId = profileId
      this.showAiDialog = true
    },
    async sendAiQuestionHandler(messageText) {
      this.aiLoading = true
      this.sendAiQuestion({
        profileId: this.aiProfileId,
        question: messageText,
      })
        .then(response => {
          this.aiAnswer = response || {}
          this.aiLoading = false
        })
        .catch(() => {
          this.aiLoading = false
        })
    },
    async sendAiAnswerHandler(answer) {
      this.showAiDialog = false
      this.addMessage({
        messageText: answer,
        needAck: false,
        mediaLibraryFiles: null,
      })
      this.sendAiAnswer({
        finalAnswer: answer,
        answerId: this.aiAnswer.id,
      })
      this.aiAnswer = {}
      this.aiQuestion = ''
    },
    closeAiDialog() {
      this.showAiDialog = false
      this.aiAnswer = {}
      this.aiQuestion = ''
      this.aiProfileId = false
    },
  },
}
</script>

<style lang="scss" scoped>
.chat {
  display: flex;
  height: 100%;
  max-height: calc(100vh - 80px);
}
</style>
